/** As chaves com que o app Flutter libera o agendamento: o hub e cada serviço. */
const HUB_FLAG = 'mobility_scheduling';
const COOPERATIVE_FLAG = 'mobility_scheduling_coop_taxi_enable';
const CAR_DRIVER_FLAG = 'mobility_scheduling_car_driver_enable';

/** As flags do feature-flag-service (`currentFeatures(system: USER_APP)`) que o agendamento de
 *  carro lê. O customer-api repassa só estas; o resto da lista do legado não sai de lá. */
export const MOBILITY_SCHEDULING_FEATURE_FLAGS = [
  HUB_FLAG,
  COOPERATIVE_FLAG,
  CAR_DRIVER_FLAG,
] as const;

export interface MobilitySchedulingAccessInput {
  /** `policyAccess` contém `mobility`; `null` = não resolvido. */
  mobilityPolicy: boolean | null;
  /** `currentFeatures(USER_APP)` já filtradas pelo customer-api; `null` = não resolvido. */
  featureFlags: readonly string[] | null;
  /** `spendingBalanceOverflow.blocked`; `null` = não resolvido. */
  spendingBlocked: boolean | null;
}

export interface MobilitySchedulingEntry {
  cooperative: boolean;
  carDriver: boolean;
}

const HIDDEN: MobilitySchedulingEntry = { cooperative: false, carDriver: false };

/**
 * Quais serviços do agendamento de carro aparecem — a MESMA regra no chat e nas telas: a do hub
 * do legado (flag do hub + flag do serviço + política `mobility` + gastos não bloqueados). Qualquer dado não resolvido esconde os dois, como na `mobility99Entry`;
 * o bloqueio de gastos só libera quando a resposta diz que NÃO há bloqueio.
 */
export function mobilitySchedulingEntry(
  input: MobilitySchedulingAccessInput,
): MobilitySchedulingEntry {
  const { mobilityPolicy, featureFlags, spendingBlocked } = input;
  if (mobilityPolicy !== true || spendingBlocked !== false || featureFlags === null) return HIDDEN;
  if (!featureFlags.includes(HUB_FLAG)) return HIDDEN;
  return {
    cooperative: featureFlags.includes(COOPERATIVE_FLAG),
    carDriver: featureFlags.includes(CAR_DRIVER_FLAG),
  };
}
